<template>
  <div>
    <material-card class="ly_card" title="次から本番です">
      <div class="el_card_content">
        例題のように3コマのストーリーを読み、そこであなたが取るかもしれない行動についてそれぞれ、「する」または「しない」のどちらかを選んでください。
      </div>
      <div class="el_card_content">
        これから始まる本番では、25個のストーリーが表示されますので、順番に答えていってください。
      </div>
      <material-button
        class="ly_button"
        text="始める"
        :link="{ name: 'problem', params: { id: 1 } }"
        font-size="36px"
        padding="17px 56px 17px 56px"
      ></material-button>
    </material-card>
    <!-- <answered class="ly_answered"></answered> -->
  </div>
</template>

<script>
import MaterialCard from '../molcules/MaterialCard'
import MaterialButton from '../atoms/MaterialButton'
import Answered from '../molcules/Answered'
export default {
  name: 'Start',
  components: { Answered, MaterialCard, MaterialButton },
}
</script>

<style scoped>
.ly_card {
  position: relative;
  top: 73px;
}

.ly_answered {
  position: absolute;
  left: 828px;
  top: 73px;
}
.ly_button {
  position: relative;
  /* left: 40%; */
}

.el_card_content {
  text-align: left;
  padding-top: 73px;
  padding-left: 63px;
  width: 602px;
  height: 152px;
  font-family: Noto Sans JP;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 35px;
}
</style>
